import { useEffect, useRef, useState } from 'react';
import { Check, ChevronDown, CircleAlert, CircleHelp, ExternalLink, MessageCircle } from 'lucide-react';
// import { useCurrentUser } from '@beholos/holoscommon';

const SMART_FIT_FEATURES = [
  'Acceso a +95 sedes Smart Fit en Perú.',
  'Sin costos de matrícula, ni mantenimiento.',
  'Sin contrato anual.',
  'Acceso ilimitado a peso libre, máquinas, pesas y barras.',
  'Clases grupales con profesores.',
  'Sillones de masajes.',
  '5 invitados al mes en el gimnasio que quieras.',
  '¿Viajas fuera de Perú? Tendrás acceso a +2.000 gimnasios en LATAM.',
];

export function AdditionalBenefitsAccordion() {
  const [isOpen, setIsOpen] = useState(false);
  const popupTimeoutRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (popupTimeoutRef.current) {
        window.clearTimeout(popupTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="mt-10">
      <div className="overflow-hidden rounded-2xl border border-border bg-card/60">
        <button
          type="button"
          className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left hover:bg-muted/40 md:px-6"
          aria-expanded={isOpen}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <div className="flex items-center gap-3 md:gap-4">
            <div className="flex h-10 w-16 shrink-0 items-center justify-center rounded-md bg-black px-1.5">
              <img src="/user/smartfit-logo.png" alt="Smart Fit" className="h-full w-full object-contain" />
            </div>
            <div className="min-w-0">
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-serif text-base font-semibold md:text-lg">Plan Black Smart Fit</span>
                <span className="rounded-full bg-prosper px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-prosper-foreground">
                  Beneficio exclusivo de Holos
                </span>
              </div>
              <p className="mt-0.5 text-xs text-muted-foreground">Pago único · Disponible desde el Plan Basic en adelante</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <span className="hidden text-sm font-semibold text-foreground sm:inline">Ver beneficio</span>
            <ChevronDown
              className={`h-5 w-5 shrink-0 text-muted-foreground transition-transform ${isOpen ? 'rotate-180' : ''}`}
            />
          </div>
        </button>

        {isOpen && (
          <div className="border-t border-border bg-background/40 px-4 py-5 md:px-6">
            <div className="mb-4 flex items-start gap-2 rounded-xl border border-prosper/30 bg-prosper/10 p-3 text-xs text-foreground/90">
              <CircleAlert className="mt-0.5 h-4 w-4 shrink-0 text-prosper" />
              <span>
                <span className="font-semibold">Válido para usuarios Holos con un plan activo desde Basic. Stock Limitado .</span>{' '}
                <span className="text-foreground/70">El add-on Smart Fit es un pago único y no se renueva automáticamente. Tienes 15 días desde la compra para activar tu membresía en cualquier sede Smart Fit.</span>
              </span>
            </div>

            <div className="mb-4 grid grid-cols-2 gap-3">
              {([{ label: '1 mes', price: 'S/129' }, { label: '3 meses', price: 'S/348' }] as const).map(({ label, price }) => (
                <div key={label} className="rounded-xl border border-border bg-card px-4 py-3 text-center">
                  <p className="text-xs text-muted-foreground">{label}</p>
                  <p className="mt-0.5 font-serif text-xl font-semibold text-foreground">{price}</p>
                </div>
              ))}
            </div>

            <ul className="grid gap-2 sm:grid-cols-2">
              {SMART_FIT_FEATURES.map((feature) => (
                <li key={feature} className="flex gap-2 text-xs text-foreground/80">
                  <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-prosper" strokeWidth={3} />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            <a
              href="https://wa.link/kc1xe1"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-full bg-prosper px-4 py-3 text-sm font-semibold text-prosper-foreground hover:bg-prosper/90"
            >
              <MessageCircle className="h-4 w-4" />
              Comprar por WhatsApp
            </a>

            <a
              href="https://beholos.com/partners/holos/smartfit"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 flex items-center justify-between gap-3 rounded-xl border border-border bg-card px-4 py-3 text-sm transition-colors hover:bg-muted/50"
            >
              <span className="flex items-center gap-2 text-foreground">
                <CircleHelp className="h-4 w-4 text-prosper" />
                <span className="font-medium">¿Dudas o preguntas sobre Smart Fit?</span>
                <span className="hidden text-muted-foreground sm:inline">Revisa la información completa del beneficio.</span>
              </span>
              <span className="inline-flex items-center gap-1 text-xs font-semibold text-foreground">
                Ver más <ExternalLink className="h-3.5 w-3.5" />
              </span>
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
